import Vue from 'vue'

Vue.filter('capitalizeFirstLetter', function (value) {
  if (typeof value == 'string'){
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
  }else{
    return value
  }
})

Vue.filter('toLowerCase', function (value) {
  if (typeof value == 'string'){
    value = value.toString()
    return value.toLowerCase()
  }else{ 
    return value
  }
})

Vue.filter('formatDate', function (value) {
  var d = new Date(value)
  if (d instanceof Date){
    const day = d.getDate().toString().length == 1 ? '0'+d.getDate():d.getDate();
    const month = d.getMonth().toString().length == 1 ? '0'+d.getMonth():d.getMonth();
    const year = d.getFullYear()
    return day + '/' + month+ '/' + year
  }else{return}
})


Vue.filter('sliceAfter', function (value,after) {
  if (typeof value == 'string' && value.length>after){
    return value.slice(0,after)+'...'
  }else{
    return value
  }
})